import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDashboardSlice } from '../slice';
import { translations as _ } from '../../../../locales/translations';
import { gaPageView } from 'utils/ga';
import DetailLeftPart from './components/DetailLeftPart';
import DetailRightPart from './components/DetailRightPart';

export default function ProductDetail(props: any) {
  const { actions } = useDashboardSlice();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getProducts());
    gaPageView(window.location.pathname + window.location.search);
  }, [actions, dispatch]);

  return (
    <div className="product-detail">
      <DetailLeftPart />
      <DetailRightPart />
    </div>
  );
}
